import $ from 'zepto';
import { objectHasOwnProperty } from '../index';

const uiObjects = {};
const hideOnBodyClickMap = {};
let savedWindowWidth;
let updateTimeout;

/* eslint no-extend-native: ["error", { "exceptions": ["String"] }] */
export function random() {
  return Math.round((((new Date().getTime() * 9301 + 49297) % 233280) / (233280)) * 100000);
}

export function $$$(id) {
  return $((id ? document.getElementById(id) : ''));
}

export function iterateOverItems(callbackName, items, event) {
  Object.keys((items || uiObjects)).forEach((key) => {
    if (objectHasOwnProperty(uiObjects, key)) {
      const item = uiObjects[key];
      if (event) {
        const targetRel = $(event.target).attr('rel');
        const toolTipTarget = targetRel ? targetRel.includes('xvx-tooltip') : false;
        if (item && !toolTipTarget && item[callbackName]) {
          item[callbackName]();
        }
      }
    }
  });
}

export function updateDomObjects(event) {
  if (updateTimeout) {
    clearTimeout(updateTimeout);
  }

  updateTimeout = setTimeout(() => {
    /* Below width check corrects for iOS 6+ bug where scrolling triggers a window resize event */
    const currentWindowWidth = $(window).width();
    if (savedWindowWidth !== currentWindowWidth) {
      iterateOverItems('update', undefined, event);
      savedWindowWidth = currentWindowWidth;
    }
  }, 200);
}

export function hideItemsOnBodyClick(event) {
  iterateOverItems('hide', hideOnBodyClickMap, event);
}

export function registerDomObjects(id, uiObject, scope, hideOnBodyClick) {
  // all ui objects
  uiObjects[id] = uiObject;

  // create a map of objects that are to be hidden when the user clicks on the body
  if (hideOnBodyClick === true) {
    hideOnBodyClickMap[id] = uiObject;
  }
}

// START PATCH: code copied from jQuery 1.11 ====================================
// This is a patch to workaround a jQuery bug (http://bugs.jquery.com/ticket/5520)
// until we upgrade to a new version
// Without this patch popups appear in the wrong place after scrolling in IE8 when using box-sizing
// TODO: remove this after uprading to jQuery >= 1.8
export function getWindow(elem) {
  return elem.nodeType === 9
    ? elem.defaultView || elem.parentWindow
    : false;
}

export function getOffset(e) {
  const elem = e[0];
  let box = {
    top: 0,
    left: 0,
  };
  const doc = elem && elem.ownerDocument;

  if (!doc) {
    return null;
  }
  const docElem = doc.documentElement;

  // BlackBerry 5, iOS 3 (original iPhone)
  if (typeof elem.getBoundingClientRect !== 'undefined') {
    box = elem.getBoundingClientRect();
  }
  const win = getWindow(doc);
  return {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
  };
}
// END PATCH ==================================================================

/**
  Insert '/ajax' at the beginning of the URL (after the 'context', if present)
  also add a time stamp query string attribute to bust IE's ajax caching
  @method ajaxifyUrl
  @return {String} string with /ajax prepended
  @public
*/
String.prototype.ajaxifyUrl = function ajaxifyUrl() {
  return this.replace(new RegExp('(//.+?)?(/ajax)?(/.*)'), '$1/ajax$3')
    .addParam('t', new Date().getTime());
};

String.prototype.replaceTokens = function replaceTokens(...args) {
  const argLen = args.length;
  let string = this;
  for (let i = 0; i < argLen; i += 1) {
    string = string.split(`{${i}}`).join(args[i]);
  }
  return string;
};

String.prototype.addParam = function addParam(name, value) {
  // todo: update to replace param if it already exists

  let exists;
  const splitString = this.split('#');
  let string = splitString[0];
  const anchor = splitString[1] || '';
  const newDelimiter = (string.indexOf('?') > -1) ? '&' : '?';

  if (value) {
    const nameEqual = `${name}=`;
    exists = new RegExp(`[?&]${nameEqual}`).test(this);
    if (!exists) {
      string += newDelimiter + nameEqual + value + anchor;
    }
  }
  return string;
};

String.prototype.escapeHTML = function escapeHTML() {
  // Create an empty div to use as a container,
  // then put the raw text in and get the HTML
  // equivalent out.
  return $('<div/>').text(this.toString()).html();
};

$(document).bind('click', (event) => {
  hideItemsOnBodyClick(event);
});
$(window).bind('resize', updateDomObjects);

export default {
  random,
  $$$,
  iterateOverItems,
  updateDomObjects,
  hideItemsOnBodyClick,
  registerDomObjects,
  getOffset,
};
